<template>
  <div id="app">
      <el-header>
        <div class="logo">
          <img src="./assets/img/toplogo.png" alt />
        </div>
        <el-menu
          :default-active="defaultActive"
          class="el-menu-demo"
          mode="horizontal"
          @select="handleSelect"
          :router="router"
        >
          <el-menu-item index="/">首页</el-menu-item>
          <!-- <el-menu-item index="/news">新闻资讯</el-menu-item> -->
          <el-menu-item index="/product">产品中心</el-menu-item>
          <el-menu-item index="/controller">自研智能终端</el-menu-item>
          <el-menu-item index="/case">经典案例</el-menu-item>
          <el-menu-item index="/goin">走进鼎锐联</el-menu-item>
          <!-- <el-menu-item index="/goin">在线演示</el-menu-item> -->

          <el-menu-item >
              <a href="https://dingruilian.com/platform/" target="_blank" style="display:block;width:100%;height:100%;color:inherit;text-decoration:none;">在线演示</a>

          </el-menu-item>
          <!-- <el-menu-item index="/download">下载APP</el-menu-item> -->
        </el-menu>
      </el-header>
      <el-main>
        <router-view />
      </el-main>
      <!-- <div class="footer" v-show="isShow"> -->
      
      <div class="footer" >
        <div class="footer-content">
          <ul class="content-nav">
            <li>
              <p>走进鼎锐联</p>
              <span>发展历程</span>
              <span>企业文化</span>
              <span>资质荣誉</span>
              <span>合作伙伴</span>
            </li>
            <!-- <li>
              <p>新闻资讯</p>
              <span>公司新闻</span>
              <span>行业动态</span>
            </li> -->
            <li>
              <p>产品中心</p>
              <!-- <span>介绍视频</span> -->
              <span>管理模式</span>
              <span>平台目标</span>
              <span>功能模块</span>
            </li>
            <li>
              <p>联系我们</p>
              <span>邮箱：whwliu@163.com</span>
              <span>电话：18616789944</span>
              <span>地址：上海市闵行区东川路555号2号楼1013室</span>
              <span @click="toOther">沪ICP备2023026579号-1 </span>
            </li>
          </ul>
          <img src="./assets/img/ercode.png" alt />
        </div>
      </div>
      <BackToTop />
  </div>
    
  
</template>

<script>
import BackToTop from "./components/BackToTop.vue";

export default {
  data() {
    return {
      router: true,
      defaultActive: "/",
      isShow: false
    };
  },
  created() {
    // 根据当前路由设置 defaultActive，保证刷新后高亮正确
    this.currentActive = this.$route.path;
  },
  watch: {
    // 监听路由变化，保持菜单高亮同步
    '$route.path'(val) {
      this.defaultActive = val;
    }
  },
  components: {
    BackToTop
  },
  methods: {
    toOther() {
      window.open("https://beian.miit.gov.cn/#/Integrated/index ", "_blank");
    },
    handleSelect(key) {
      this.isShow = this.defaultActive != key;
    }
  }
};
</script>

<style lang="scss">
* {
  padding: 0;
  margin: 0;
}
html,
body {
  height: 100%;
}

#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  min-height: 100vh;
}

.el-header {
  display: flex;
  justify-content: space-between;
  align-content: center;
  width: 1240px;
  margin: 0 auto;
  //background-color: #fff;

  .logo {
    width: 280px;
    padding: 10px;
    img {
      width: 100%;
      line-height: 60px;
    }
  }
}
.el-main {
  padding: 0 !important;
}

.footer {
  width: 100%;
  height: 216px;
  overflow: hidden;
  background-color: #14679f;
  &-content {
    width: 1240px;
    margin: 0 auto;
    padding-top: 20px;
    display: flex;
    justify-content: space-between;
    .content-nav {
      display: flex;
      justify-content: space-around;
      li {
        display: flex;
        flex-direction: column;
        padding: 0 20px;
        //justify-content: center;
        align-items: flex-start;
        p {
          font-size: 20px;
          color: #d4edff;
          padding: 10px 0;
        }
        span {
          color: #f7f7f7;
          font-weight: 300;
          padding: 5px 0;
        }
      }
    }
    img {
      width: 170px;
      height: 170px;
      padding: 10px;
    }
  }
  .copyright {
    height: 30px;
    background: #125688;
    span {
      color: #fff;
      line-height: 30px;
    }
  }
}
</style>
